// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4q0rk","label":"styles_label__TN3ol","link":"styles_link__H3acB","noLabel":"styles_noLabel__kpdSi","errorIcon":"styles_errorIcon__x0cVl"};